import React, { useState, useEffect } from 'react';

const CDN_BASE_URL = "https://storage.googleapis.com/wacofirefightersbenefit";

const Appreciation = () => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const [appreciationData, setAppreciationData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAppreciationData();
  }, []);

  const loadAppreciationData = async () => {
    try {
      const response = await fetch(`${CDN_BASE_URL}/data/appreciation.json?t=${Date.now()}`);
      if (response.ok) {
        const data = await response.json();
        // Support both array and single object for backward compatibility
        setAppreciationData(Array.isArray(data) ? data : [data]);
      } else {
        console.warn('Failed to load appreciation data');
        setAppreciationData([]);
      }
    } catch (err) {
      console.error('Error loading appreciation data:', err);
      setAppreciationData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMouseEnter = (imageName) => {
    setHoveredImage(imageName);
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  if (loading) {
    return (
      <div className="p-8 max-w-7xl mx-auto text-left mt-24 mb-24">
        <h1 className="text-left mb-12 text-[#333] text-4xl">Appreciation</h1>
        <p className="text-center py-10">Loading...</p>
      </div>
    );
  }

  if (!appreciationData || appreciationData.length === 0) {
    return (
      <div className="p-8 max-w-7xl mx-auto text-left mt-24 mb-24">
        <h1 className="text-left mb-12 text-[#333] text-4xl">Appreciation</h1>
        <p className="text-center py-10">No testimonials available.</p>
      </div>
    );
  }

  return (
    <div className="md:p-8 p-4 max-w-7xl mx-auto text-left mt-24 mb-24">
      <h1 className="text-left mb-12 text-[#333] text-4xl">Appreciation</h1>
      <div className="grid grid-cols-1 gap-8 md:p-4 p-0 text-left">
        {appreciationData.map((testimonial, index) => (
          <div
            key={testimonial.id || index}
            className="bg-white p-8 rounded-[20px] shadow-[0_2px_30px_rgba(0,0,0,0.1)] transition-transform duration-300 ease-in-out text-left"
          >
            <p
              className="text-lg leading-relaxed text-[#444] mb-6 text-left  text-[16px] md:text-[18px]"
              dangerouslySetInnerHTML={{ __html: testimonial.text }}
            />
            <p className="font-semibold text-[#666] text-left mb-8">- {testimonial.author}</p>
            <div className="mt-8 flex justify-center">
              <img
                className="max-w-[300px] h-auto rounded-[10px] transition-all duration-300 ease-in-out shadow-[0_4px_8px_rgba(0,0,0,0.1)] border-[5px] border-white"
                src={`${CDN_BASE_URL}/${testimonial.imageUrl}`}
                alt={testimonial.author}
                style={{
                  transform: hoveredImage === `img_${index}` ? 'rotate(0deg) scale(1.2)' : "rotate(-3deg) scale(1)",
                  zIndex: hoveredImage === `img_${index}` ? 1 : 0
                }}
                onMouseEnter={() => handleMouseEnter(`img_${index}`)}
                onMouseLeave={handleMouseLeave}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Appreciation;